import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-student-calendar',
  templateUrl: './student-calendar.component.html',
  styleUrls: ['./student-calendar.component.css']
})
export class StudentCalendarComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
